import { api } from "./client";
import type { Vehicle, VehicleImage, VehicleHistory } from "@/lib/types";

interface VehicleListResponse {
  vehicles: Vehicle[];
  total: number;
}

interface VehicleFilters {
  patientId?: string;
  plate?: string;
  brand?: string;
  isActive?: boolean;
  limit?: number;
  offset?: number;
}

interface CreateVehicleData {
  patientId: string;
  plate: string;
  brand: string;
  model: string;
  year: number;
  color: string;
  chassis?: string;
  renavam?: string;
  fuelType?: string;
  mileage?: number;
  engineSize?: string;
  insuranceCompany?: string;
  insurancePolicy?: string;
  insuranceExpiry?: string;
  notes?: string;
}

interface CreateImageData {
  imageUrl: string;
  thumbnailUrl?: string;
  imageType?: string;
  position?: string;
  caption?: string;
  tags?: string[];
  estimateId?: string;
}

export const vehiclesService = {
  list: (filters?: VehicleFilters) =>
    api.get<VehicleListResponse>("/vehicles", filters),

  search: (q: string, limit?: number) =>
    api.get<Vehicle[]>("/vehicles/search", { q, limit }),

  getByPlate: (plate: string) =>
    api.get<Vehicle>(`/vehicles/plate/${plate}`),

  getById: (id: string) =>
    api.get<Vehicle>(`/vehicles/${id}`),

  create: (data: CreateVehicleData) =>
    api.post<Vehicle>("/vehicles", data),

  update: (id: string, data: Partial<CreateVehicleData> & { isActive?: boolean }) =>
    api.put<Vehicle>(`/vehicles/${id}`, data),

  delete: (id: string) =>
    api.delete(`/vehicles/${id}`),

  getByOwner: (patientId: string) =>
    api.get<Vehicle[]>(`/vehicles/owner/${patientId}`),

  getHistory: (id: string) =>
    api.get<VehicleHistory>(`/vehicles/${id}/history`),

  // Images
  addImage: (vehicleId: string, data: CreateImageData) =>
    api.post<VehicleImage>(`/vehicles/${vehicleId}/images`, data),

  getImages: (vehicleId: string, imageType?: string) =>
    api.get<VehicleImage[]>(`/vehicles/${vehicleId}/images`, { imageType }),

  deleteImage: (imageId: string) =>
    api.delete(`/vehicles/images/${imageId}`),
};
